import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import Icon from 'images/success.svg'

type TProps = {}

const PaymentSuccessPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.CheckoutPage)

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex flex-col items-center gap-12">
        <div
          className="flex h-30 w-30 items-center justify-center rounded-half"
          style={{
            backgroundColor: 'rgb(254, 254, 254, .1)',
          }}
        >
          <img src={Icon} className="" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <Text tagName="span" className="font-body---40px text-green-400">
            {t('success.title')}
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-grey--50">
            {t('success.caption')}
          </Text>
        </div>
      </div>
    </div>
  )
}

export { PaymentSuccessPageContent }
